import dayjs from 'dayjs';
import { z } from 'zod';

enum OTHER_GREENHOUSE_GAS_MODAL_MESSAGE {
  BASE_YEAR = 'กรุณาเลือกปีฐาน',
  QUANTITY = 'กรุณาระบุจำนวน',
  REQUIRED = 'กรุณาเลือก',
  PERCENT_INVALID = 'จำนวนไม่ถูกต้อง',
  YEAR_TARGET = 'ปีเป้าหมาย ',
}

const yearSchema = z
  .custom((value) => dayjs.isDayjs(value) && value.isValid(), {
    message: OTHER_GREENHOUSE_GAS_MODAL_MESSAGE.YEAR_TARGET,
  })
  .optional()
  .nullable();

const gasEmissionPercentSchema = z
  .string()
  .transform((value) => Number(value))
  .refine((value) => value >= 0 && value <= 100, {
    message: OTHER_GREENHOUSE_GAS_MODAL_MESSAGE.PERCENT_INVALID,
  })
  .optional();

const gasEmissionQuantitySchema = z
  .string()
  .transform((value) => Number(value))
  .refine((value) => value >= 0, {
    message: OTHER_GREENHOUSE_GAS_MODAL_MESSAGE.PERCENT_INVALID,
  })
  .optional();

export const OtherGreenhouseGasModalSchema = z.object({
  id: z.number().optional(),
  scopeId: z.number({
    required_error: OTHER_GREENHOUSE_GAS_MODAL_MESSAGE.REQUIRED,
  }),
  baseYear: z
    .object({
      year: yearSchema.optional().nullable(),
      gasEmissionQuantity: z
        .string()
        .transform((value) => Number(value))
        .optional()
        .nullable(),
    })
    .nullable(),
  nearTermTarget: z.object({
    year: yearSchema,
    gasEmissionPercent: gasEmissionPercentSchema,
    gasEmissionQuantity: gasEmissionQuantitySchema,
  }),
  longTermTarget: z.object({
    year: yearSchema,
    gasEmissionPercent: gasEmissionPercentSchema,
    gasEmissionQuantity: gasEmissionQuantitySchema,
  }),
});
